import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(other)/go-app/content.js");
